import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0 -.38146 .38146 0 1.7007 22.299)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 27c0 14.893 12.107 27 27 27s27-12.107 27-27-12.107-27-27-27-27 12.107-27 27z",
  fill: "#404040",
  opacity: ".7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.135 27.023-7.394-7.8c-0.245-0.259-0.618-0.374-0.977-0.302s-0.65 0.32-0.764 0.652c-0.113 0.332-0.032 0.695 0.213 0.954l6.778 7.148-6.778 7.148c-0.245 0.259-0.326 0.622-0.213 0.954 0.114 0.331 0.405 0.58 0.764 0.652 0.36 0.072 0.732-0.043 0.977-0.302l7.394-7.8c0.186-0.196 0.281-0.455 0.263-0.719-0.017-0.217-0.11-0.423-0.263-0.585z",
  fill: "#fff"
})), 'BackToTop');